module.exports = __webpack_public_path__ + "static/zhanyaoxing-8198a784bdb503aff5563a90d8de4389.jpeg";